if (!customElements.get("sticky-atc")) {
  customElements.define(
    "sticky-atc",
    class StickyAtc extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          prodTitle: ".m-sticky-addtocart--title",
          mainImage: ".m-sticky-addtocart--image",
          addToCart: ".m-add-to-cart",
          buyNowBtn: ".m-product-dynamic-checkout",
          variantIdSelect: '[name="id"]',
          foxkitBtn: ".foxkit-button",
          select: "select",
        };
        this.hasCustomFields = !!document.querySelector(".m-main-product--info .m-product-custom-field");
      }

      connectedCallback() {
        try {
          this.mainProduct = document.querySelector("product-info[id^='MainProduct']");
          if (!this.mainProduct) return;
          this.container = this.closest(".m-sticky-addtocart");
          if (!this.container) return;
          this.mainProductForm = document.querySelector(".m-product-form--main");
          this.mainProductInfo = document.querySelector(".m-main-product--info");
          this.mainAddToCart = this.mainProductForm ? this.mainProductForm.querySelector(".m-add-to-cart") : null;
          this.mainDynamicCheckout = this.mainProductForm ? this.mainProductForm.querySelector(this.selectors.buyNowBtn) : null;
          this.disableSelectedVariantDefault = this.mainProduct.dataset.disableSelectedVariantDefault === "true" || false;
          this.domNodes = queryDomNodes(this.selectors, this.container);

          this.init();
        } catch (error) {
          console.warn("Sticky ATC error in connectedCallback:", error);
        }
      }

      init() {
        try {
          if (!this.mainAddToCart) {
            if (this.container) {
              this.container.style.setProperty("--m-translate-y", 0);
            }
            return;
          }

          this.variantData = this.getVariantData();

          const headerHeight = (window.MinimogSettings && window.MinimogSettings.headerHeight) || 66;
          const rootMargin = `${headerHeight}px 0px 0px 0px`;

          if ("IntersectionObserver" in window) {
            this.observer = new IntersectionObserver(
              (entries) => {
                entries.forEach((entry) => {
                  if (this.container) {
                    if (entry.intersectionRatio !== 1) {
                      this.container.style.setProperty("--m-translate-y", 0);
                    } else {
                      this.container.style.setProperty("--m-translate-y", "100%");
                    }
                  }
                  document.documentElement.classList[entry.intersectionRatio !== 1 ? "add" : "remove"]("stick-atc-show");
                });
              },
              { threshold: 1, rootMargin }
            );
          }

          if (this.disableSelectedVariantDefault) {
            this.handleDisableSelectedVariantDefault();
          }

          const { prodTitle, mainImage } = this.domNodes;
          if (prodTitle) prodTitle.addEventListener("click", () => typeof __scrollToTop === "function" && __scrollToTop());
          if (mainImage) mainImage.addEventListener("click", () => typeof __scrollToTop === "function" && __scrollToTop());

          this.handleCustomFields();

          this.setObserveTarget();
          this.syncWithMainProductForm();

          if (window.MinimogTheme && window.MinimogTheme.config && window.MinimogTheme.config.mediaQueryMobile) {
            const mql = window.matchMedia(MinimogTheme.config.mediaQueryMobile);
            mql.onchange = this.setStickyAddToCartHeight.bind(this);
          }
          this.setStickyAddToCartHeight();

          if (this.domNodes && this.domNodes.select) {
            this.domNodes.select.addEventListener("change", (e) => {
              try {
                const { target } = e;
                const variantPicker = this.mainProduct.querySelector('variant-picker');
                const selectElement = this.querySelector(this.selectors.variantIdSelect);
                const selectedVariantId = selectElement ? selectElement.value : '';
                this.currentVariant = this.variantData.find((variant) => variant.id === Number(selectedVariantId));
                
                let soldOutString = (window.MinimogStrings && window.MinimogStrings.soldOut) || 'Sold out';
                let unavailableString = (window.MinimogStrings && window.MinimogStrings.unavailable) || 'Unavailable';
                
                this.currentVariant ? this.toggleAddButton(!this.currentVariant.available, soldOutString) : this.toggleAddButton(true, unavailableString);

                const selectedOption = target.options[target.selectedIndex];
                if (!selectedOption) return;
                const optionData = selectedOption.dataset.options;
                const selectedOptionIds = optionData ? optionData.split(',').filter(id => id) : [];

                if (variantPicker) {
                  const elementsToDispatch = [];
                  selectedOptionIds.forEach((optionId) => {
                    const input = variantPicker.querySelector(`[data-option-value-id="${optionId}"]`);
                    if (input) {
                      const { tagName } = input;
                      switch (tagName) {
                        case "OPTION":
                          const inputParent = input.parentNode; // select tag
                          if (inputParent && inputParent.value !== input.value) {
                            inputParent.value = input.value;
                            if (!elementsToDispatch.includes(inputParent)) {
                              elementsToDispatch.push(inputParent);
                            }
                          }
                          break;
                        case "INPUT":
                          if (!input.checked) {
                            input.checked = true;
                            if (!elementsToDispatch.includes(input)) {
                              elementsToDispatch.push(input);
                            }
                          }
                          break;
                      }
                    }
                  });
                  elementsToDispatch.forEach((el) => {
                    el.dispatchEvent(new Event("change", { bubbles: true }));
                  });
                }
              } catch (err) {
                console.warn("Sticky ATC error on option change:", err);
              }
            });
          }
        } catch (error) {
          console.warn("Sticky ATC error in init:", error);
        }
      }

      getVariantData() {
        try {
          const jsonScript = this.container.querySelector('[type="application/json"]');
          this.variantData = this.variantData || (jsonScript ? JSON.parse(jsonScript.textContent) : []);
          return this.variantData;
        } catch (error) {
          console.warn("Sticky ATC error in getVariantData:", error);
          return [];
        }
      }

      setObserveTarget() {
        if (this.observer && this.mainProductForm) {
          this.observer.observe(this.mainProductForm);
          this.observeTarget = this.mainProductForm;
        }
      }

      setUnavailable() {
        const productForm = this.querySelector('.m-product-form');
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');

        if (addButton) {
          let unavailableString = (window.MinimogStrings && window.MinimogStrings.unavailable) || 'Unavailable';
          this.toggleAddButton(true, unavailableString);
        }
      }

      toggleAddButton(disable = true, text, modifyClass = true) {
        try {
          const productForm = this.querySelector('.m-product-form');
          if (!productForm) return;
          const addButton = productForm.querySelector('[name="add"]');
          const addButtonText = productForm.querySelector('[name="add"] > span.m-add-to-cart--text');
          if (!addButton) return;

          if (disable) {
            addButton.setAttribute('disabled', 'disabled');
            if (text && addButtonText) addButtonText.textContent = text;
          } else {
            addButton.removeAttribute('disabled');
            if (addButtonText) {
              addButtonText.innerHTML = (window.MinimogStrings && window.MinimogStrings.addToCart) || 'Add to cart';
            }
          }
        } catch (error) {
          console.warn("Sticky ATC error in toggleAddButton:", error);
        }
      }

      handleDisableSelectedVariantDefault() {
        try {
          let urlParams = new URLSearchParams(window.location.search);
          if (urlParams.has("variant")) return;

          const pickerFields = this.querySelector('.m-product-option--dropdown-select');
          if (pickerFields) {
            pickerFields.value = '';
          }
          this.setUnavailable();
        } catch (error) {
          console.warn("Sticky ATC error in handleDisableSelectedVariantDefault:", error);
        }
      }

      setStickyAddToCartHeight() {
        try {
          document.documentElement.style.setProperty("--f-sticky-atc-bar-height", this.offsetHeight + "px");
          if (window.MinimogSettings) {
            window.MinimogSettings.stickyAddToCartHeight = this.offsetHeight;
          }
        } catch (error) {
          console.warn("Sticky ATC error in setStickyAddToCartHeight:", error);
        }
      }

      syncWithMainProductForm() {
        try {
          const variantInput = this.querySelector('[name="id"]');
          if (!variantInput) return;
          if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
            MinimogEvents.subscribe(MinimogTheme.pubSubEvents.variantChange, (e) => {
              try {
                const isMainProduct = this.mainProduct && e.data.sectionId === this.mainProduct.dataset.sectionId;
                if (!isMainProduct) return;
                this.currentVariant = e.data.variant;
                
                let soldOutString = (window.MinimogStrings && window.MinimogStrings.soldOut) || 'Sold out';
                let unavailableString = (window.MinimogStrings && window.MinimogStrings.unavailable) || 'Unavailable';

                if (this.currentVariant) {
                  variantInput.value = e.data.variant.id;
                  this.toggleAddButton(!this.currentVariant.available, soldOutString);
                } else {
                  variantInput.value = '';
                  this.toggleAddButton(true, unavailableString);
                }
              } catch (err) {
                console.warn("Sticky ATC error in variantChange subscription:", err);
              }
            });
          }
        } catch (error) {
          console.warn("Sticky ATC error in syncWithMainProductForm:", error);
        }
      }

      handleCustomFields() {
        try {
          if (!this.hasCustomFields) return;

          const { addToCart, buyNowBtn, foxkitBtn } = this.domNodes;

          let hasCustomFieldRequired = false;
          const customFields = document.querySelectorAll(".m-main-product--info .m-product-custom-field");
          if (customFields.length > 0) {
            customFields.forEach((item) => {
              const field = item.querySelector(".form-field");
              if (field && field.value == "" && field.hasAttribute("required")) {
                hasCustomFieldRequired = true;
              }
            });
          }

          if (hasCustomFieldRequired && addToCart) {
            addToCart.addEventListener("click", (e) => {
              e.preventDefault();
              e.stopPropagation();
              if (typeof __scrollToTop === "function") {
                __scrollToTop(this.mainProductInfo, () => this.mainAddToCart && this.mainAddToCart.click());
              }
            });
          }
          if (buyNowBtn) {
            buyNowBtn.addEventListener(
              "click",
              (e) => {
                if (typeof validateForm === "function") {
                  const missing = validateForm(this.mainProductInfo);
                  if (missing.length > 0) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (typeof __scrollToTop === "function") {
                      __scrollToTop(this.mainProductInfo, () => this.mainDynamicCheckout && this.mainDynamicCheckout.click());
                    }
                  }
                }
              },
              true
            );
          }
          if (foxkitBtn) {
            foxkitBtn.addEventListener("click", (e) => {
              e.preventDefault();
              if (typeof __scrollToTop === "function") {
                __scrollToTop(this.mainProductInfo, () => this.mainAddToCart && this.mainAddToCart.click());
              }
            });
          }
        } catch (error) {
          console.warn("Sticky ATC error in handleCustomFields:", error);
        }
      }
    }
  );
}
